import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    MenuItem,
    TextField,
    Typography,
    useTheme
} from "@mui/material";
import {useTranslation} from "react-i18next";
import '../../../style/SalesMarketing.css';
import * as React from "react";
import {useContext, useState} from "react";
import Box from "@mui/material/Box";
import {
    COUPON_CODE_STATUS_DELIVERED,
    COUPON_CODE_STATUS_NOT_USED,
    COUPON_CODE_STATUS_USED
} from "../../../component/Constants";
import {GlobalContext} from "../../../../../util/state/GlobalContextProvider";
import {setSnackbar} from "../../../../../util/state/globalAction";
import {snackbarTypes} from "../../../../../util/state/globalVariables";
import {useCouponActions} from "../../../service/useCouponActions";
import {useStatusValuesCoupon} from "../../../component/useStatusValuesCoupon";

interface CouponCodeUpdateModalProps {
    open: boolean,
    handleClose: Function,
    selectedCouponCode: any
}

const CouponCodeUpdateModal = ({
                                   open,
                                   handleClose,
                                   selectedCouponCode
                               }: CouponCodeUpdateModalProps) => {
    const {t} = useTranslation(['salesmarketing']);
    const theme = useTheme();
    const [status, setStatus] = useState(selectedCouponCode.status);
    const [note, setNote] = useState(selectedCouponCode.note);
    const [noteError, setNoteError] = useState("");
    const {updateCoupon} = useCouponActions();
    const {dispatchGlobalData} = useContext(GlobalContext);
    const {getStatusLabel} = useStatusValuesCoupon();

    const statuses = [
        {
            key: COUPON_CODE_STATUS_NOT_USED,
            value: getStatusLabel(COUPON_CODE_STATUS_NOT_USED)
        },
        {
            key: COUPON_CODE_STATUS_DELIVERED,
            value: getStatusLabel(COUPON_CODE_STATUS_DELIVERED)
        }
    ];

    const CONFIRM_SNACKBAR = {
        type: setSnackbar,
        payload: {
            snackbar: {
                message: t('salesmarketing:coupon.updateCode.success'),
                type: snackbarTypes.success,
                show: true,
                autoClose: true,
            }
        }
    };
    const handleChangeStatus = (event: React.ChangeEvent<HTMLInputElement>) => {
        setStatus(event.target.value);


    };
    const handleChangeNote = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.value) {
            setNoteError("");
        }
        setNote(event.target.value);
    };

    const confirmUpdateCode = () => {
        if(!note) {
            setNoteError(t('salesmarketing:coupon.createForm.requiredCheck'))
        } else {
            let payload = {
                id: selectedCouponCode.id,
                status: status,
                idCouponplan: selectedCouponCode.idCouponplan,
                note: note
            }
            updateCoupon(payload).then((res:any) => {
                handleClose(true);
                dispatchGlobalData(CONFIRM_SNACKBAR);
            })
        }
    }

    return (
        <Dialog disableEscapeKeyDown maxWidth={"md"} fullWidth={true} open={open}
                onClose={() => {
                    return;
                }}>
            <DialogTitle>
                <Box sx={{display: 'flex', alignItems: 'center'}}>
                    <Typography sx={{paddingLeft: "10px"}} fontWeight={"bold"} color={"primary"}>
                        {t('salesmarketing:coupon.updateCode.title')}
                    </Typography>
                </Box>
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={2} sx={{padding: "15px"}} alignItems={"center"}>
                    <Grid item xs={4}>
                        <TextField
                            fullWidth
                            name="couponCode"
                            label={t('salesmarketing:coupon.updateCode.couponCode')}
                            value={selectedCouponCode.couponCode}
                            disabled
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <TextField
                            disabled={selectedCouponCode.status === COUPON_CODE_STATUS_DELIVERED || selectedCouponCode.status === COUPON_CODE_STATUS_USED}
                            fullWidth
                            required
                            name="status"
                            label={t('salesmarketing:coupon.updateCode.status')}
                            select
                            value={status}
                            onChange={handleChangeStatus}
                        >
                            {statuses?.map((a) => (
                                <MenuItem key={a.key} value={a.key}>
                                    {a.value}
                                </MenuItem>
                            ))}
                        </TextField>

                    </Grid>
                    <Grid item xs={4}>
                        <TextField
                            required
                            fullWidth
                            name="note"
                            inputProps={{maxLength: 128}}
                            label={t('salesmarketing:coupon.updateCode.note')}
                            value={note}
                            onChange={handleChangeNote}
                            error={!!noteError}
                            helperText={noteError}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions sx={{backgroundColor: theme.palette.neutral.bright, padding: "15px"}}>
                <Button variant={"outlined"} color={"accent"}
                        onClick={() => {
                            handleClose();
                        }}>
                    {t('salesmarketing:coupon.buttons.cancel')}
                </Button>
                <Button color={"accent"} onClick={() => {
                    confirmUpdateCode();
                }}>
                    {t('salesmarketing:coupon.buttons.save')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default CouponCodeUpdateModal;